/*
 * @Author: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @Date: 2023-11-27 11:09:33
 * @LastEditors: weixin_44214515 weixin_44214515@noreply.gitcode.com
 * @LastEditTime: 2024-06-04 17:15:11
 * @FilePath: /front-vps-admin/src/public/store/getters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const getters = {
    user: state => state.user.user,
    currentOrgan : state => state.user.currentOrgan,
    siteInfo: state => state.site.siteInfo || {},
    codes: state => state.code.codes || {},
    theme: state => state.app.theme,
    adminLayoutMode: state => state.app.adminLayoutMode, // 管理控制台布局模式
    sidebar: state => state.app.sidebar,
    language: state => state.app.language,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    menus: state => state.menus.menus,                              //从后台获取到的menus
    roles: state => state.user.roles,                     //从后台获取到的menus
    routes: state => state.router.routes,
    isFrameworkRouteLoaded : state => state.router.isFrameworkRoutedLoaded,
    rules: state => state.errorLog.rules,
    preview: state => state.previewPage.pageContent
};
export default getters